import { httpClient } from "./httpClient";

export const getTypes = () => httpClient.get(`/testtype`);

export const getType = (id: string) => httpClient.get(`/testtype/${id}`);

export const putType = (typeBody: any) => httpClient.put(`/testtype/${typeBody.id}`, typeBody);

export const postType = (typeBody: any) => httpClient.post(`/testtype`, typeBody);
